import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"

import { environment } from '../../../environments/environment';
import { data } from 'src/app/data';
import { Product } from '../interfaces/product';
import { Observable, of } from 'rxjs';
import { Category } from '../interfaces/category';

@Injectable({
  providedIn: "root"
})
export class ShopService {
  controllerName = "shop/";
  constructor(private http: HttpClient) { }
  getoneproductbyslug(prodslug) {
    return this.http.get<any>(environment.apiurl + this.controllerName + "getoneproductbyslug/" + prodslug);
  }
  
  getCategories(): Observable<Category[]> {
    var r = data.categories;
    return of(r);
  }
  
  getProductsByCategory(categorySlug: string | null, options: any): any {
    var r = data.getProductsByCategory(categorySlug, options);
    return of(r);
  }

  getProductsByBrand(brandSlug: string | null, options: any): any {
    var r = data.getProductsByBrand(brandSlug, options);    
    return of(r);
  }
  getProductsByTag(brandSlug: string | null, options: any): any {
    var r = data.getProductsByTag(brandSlug, options);    
    return of(r);
  }
  
  getRandomProducts(): Observable<Product[]> {
    var r = [...data.products];
    const shuffled = r.sort(() => 0.5 - Math.random());
    let random = shuffled.slice(0,18);
    return of(random);
  }

  getProductsBySearch(categorySlug: string = null,query: string): Observable<Product[]> {
    var r = [...data.products];
    if(categorySlug!=null){
      r = data.searchproductsbycatslug(categorySlug)  
    }
    r = r.filter(el=>{
      if(el.name.toLowerCase().includes(query.toLowerCase()))
      return el
    });

    return of(r);
  }
  getProductsBySearchResolver(categorySlug: string = null,query: string): any {
    var r = [...data.products];
    if(categorySlug!=null){
      r = data.searchproductsbycatslug(categorySlug)  
    }
    r = r.filter(el=>{
      if(el.name.toLowerCase().includes(query.toLowerCase()))
      return el
    });
    var datas = {filter:[],products:r,pagination:{}}

    return of(datas);
  }
  order(data) {
    return new Promise((res)=>{
      this.http.post<{status:string,data:any}>(environment.apiurl + this.controllerName+"/order",data).subscribe(rest=>{
        res(rest);
      })
    })
  }
  createorder(data) {
    return new Promise((res)=>{
      this.http.post<{status:string,data:any}>(environment.apiurl + this.controllerName+"/createorder",data).subscribe(rest=>{
        res(rest);
      })
    })
  }
  updateOrder(data) {
    return new Promise((res)=>{
      this.http.post<{status:string,data:any}>(environment.apiurl + this.controllerName+"/updateorder",data).subscribe(rest=>{
        res(rest);
      })
    })
  }
  ordergetforuser(_id) {
    return new Promise((res)=>{
      this.http.get<{status:string,data:any}>(environment.apiurl + this.controllerName+"ordergetforuser/"+_id).subscribe(rest=>{
        res(rest);
      })
    })
  }
  reviewpost(data) {
    return new Promise((res)=>{
      this.http.post<{status:string,data:any}>(environment.apiurl + this.controllerName+"/reviewpost",data).subscribe(rest=>{
        res(rest);
      })
    })
  }
  contactus(data) {
    return new Promise((res)=>{
      this.http.post<{status:string,data:any}>(environment.apiurl + this.controllerName+"/contactus",data).subscribe(rest=>{
        res(rest);
      })
    })
  }
  createquote(data) {
    return new Promise((res)=>{
      this.http.post<{status:string,data:any}>(environment.apiurl + this.controllerName+"/createquote",data).subscribe(rest=>{
        res(rest);
      })
    })
  }
}
